import OrderForm from "@/components/OrderPage/OrderForm/index";
import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";
import find from "lodash-es/find";
import $rate from "@/mixins/rate";
import $exponent from "@/mixins/exponent";
import $thousandMask from "@/mixins/thousandMask";

export default {
  name: "order-card",
  components: {
    OrderForm
  },
  mixins: [$rate, $exponent, $thousandMask],
  data() {
    return {
      orderCardLoader: true,
      tab: 0,
      selectedCoinData: {
        name: this.$t("orderPage.orderCard.bitcoin"),
        symbol: "BTC",
        tomanPrice: "503,927,863",
        dollarPrice: "19,567.64842",
        priceChanges: "0.15%",
        icon: require("../../../assets/image/IRR.svg"),
        amountSign: true
      },
      orderType: [
        {
          type: "BUY",
          isActive: false
        },
        {
          type: "SELL",
          isActive: false
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      fromCurrencyId: types.market.getters.GET_SELECTED_BASE_CURRENCY,
      toCurrency: types.market.getters.GET_TO_CURRENCY,
      defaultToCurrency: types.market.getters.GET_DEFAULT_TO_CURRENCY,
      currencies: types.currencies.getters.GET_CURRENCIES,
      markets: types.market.getters.GET_AVAILABLE_MARKET_DATA,
      wallets: types.wallets.getters.GET_WALLETS,
      buySellState: types.buySellState.getters.GET_BUY_SELL_STATE
    }),
    fromCurrency() {
      let currencies = [...this.currencies];
      currencies = currencies?.find(
        currency => currency.id === this.fromCurrencyId
      );
      return currencies;
    },
    desCurrency() {
      let des = this.toCurrency;
      if (Object.entries(des).length === 0) {
        des = this.defaultToCurrency;
      }
      return des;
    },
    balance() {
      if (this.wallets) {
        if (
          Object.entries(this.wallets.wallets).length !== 0 &&
          this.buySellState
        ) {
          if (this.buySellState === "buy") {
            return this.wallets.wallets.find(
              wallet => wallet.currency.id === this.fromCurrency.id
            );
          } else {
            return this.wallets.wallets.find(
              wallet => wallet.currency.id === this.desCurrency.id
            );
          }
        }
      }
    },
    market() {
      if (this.desCurrency) {
        return find([...this.markets], {
          base_currency_id: this.fromCurrencyId,
          asset_currency_id: this.desCurrency.id
        });
      }
    },
    marketDirection() {
      if (this.market) {
        this.orderCardLoader = false;
        return this.market.direction_type;
      }
    },
    toCurrencyPrice() {
      if (this.desCurrency) {
        return this.$thousandMask(this.desCurrency.price.toString());
      }
    },

    baseExponent() {
      return this.market?.base_computational_exponent;
    },

    assetExponent() {
      return this.market?.asset_computational_exponent;
    },

    rate() {
      if (this.fromCurrency && this.desCurrency && this.buySellState) {
        const rate = this.$rate(
          this.fromCurrency,
          this.desCurrency,
          this.buySellState
        );
        const expo = this.$exponent(rate, this.baseExponent);
        return this.$thousandMask(expo);
      }
    }
  },

  methods: {
    ...mapActions({
      setBuySellState: types.buySellState.actions.SET_BUY_SELL_STATE
    })
  },

  watch: {
    tab(value) {
      let state = value === 0 ? "buy" : "sell";
      this.setBuySellState(state);
    },
    marketDirection: {
      immediate: true,
      handler(value) {
        this.orderType.forEach(elem => {
          if (value === "BOTH") {
            elem.isActive = true;
            this.tab = 0;
          } else if (value === "SELL") {
            elem.isActive = elem.type === "SELL";
            this.tab = 1;
          } else if (value === "BUY") {
            elem.isActive = elem.type === "BUY";
            this.tab = 0;
          }
        });
      }
    }
  }
};
